import { Pipe, PipeTransform } from '@angular/core';
import { ProductSearchViewModelGenericSearchResultViewModel as ProductSearchResult } from '@models/api-search.models';
import { SearchResultCmsPageViewModel } from '@models/api.models';

@Pipe({
    name: 'showSearchContent',
    standalone: true
})
export class ShowSearchContentPipe implements PipeTransform {
    transform(
        contentResults: SearchResultCmsPageViewModel[] | null | undefined,
        productResults: ProductSearchResult | null | undefined
    ): boolean {
        const hasContent = (contentResults && contentResults.length > 0) || false;
        const hasProducts = getHasProducts(productResults ?? {});
        const hasSuggestions = getHasSuggestions(productResults ?? {});
        const hasRedirects = getHasRedirects(productResults ?? {});
        return hasContent || hasProducts || hasSuggestions || hasRedirects;
    }
}

const getHasProducts = (productResults: ProductSearchResult | null): boolean => {
    if (!productResults) {
        return false;
    }
    const { products } = productResults;
    return (products && products.length > 0) || false;
};

const getHasSuggestions = (productResults: ProductSearchResult | null): boolean => {
    if (!productResults) {
        return false;
    }
    const { suggestions } = productResults;
    const hasDidYouMean = (suggestions?.didYouMean && suggestions.didYouMean.length > 0) || false;
    const hasSearchWords = (suggestions?.searchWords && suggestions.searchWords.length > 0) || false;
    return hasDidYouMean || hasSearchWords;
};

const getHasRedirects = (productResults: ProductSearchResult | null): boolean => {
    if (!productResults) {
        return false;
    }

    const { redirectUrls } = productResults;
    return (redirectUrls && redirectUrls.length > 0) || false;
};
